import { useLeadsStore } from '../stores/leads.store'

export function useLeads() {
  const leads = useLeadsStore((state) => state.leads)
  const meta = useLeadsStore((state) => state.meta)
  const isLoading = useLeadsStore((state) => state.isLoading)
  const error = useLeadsStore((state) => state.error)
  const followUpLoading = useLeadsStore((state) => state.followUpLoading)

  const fetchLeads = useLeadsStore((state) => state.fetchLeads)
  const assignLead = useLeadsStore((state) => state.assignLead)
  const sendFollowUpEmail = useLeadsStore((state) => state.sendFollowUpEmail)
  const clearError = useLeadsStore((state) => state.clearError)

  const updateLead = useLeadsStore((state) => state.updateLead)
  const updateLeadStatus = useLeadsStore((state) => state.updateLeadStatus)

  return {
    leads,
    meta,
    isLoading,
    error,
    followUpLoading,
    fetchLeads,
    assignLead,
    sendFollowUpEmail,
    clearError,
    updateLead,
    updateLeadStatus,
  }
}
